import { SvgIcon } from '@mui/material';
import { memo } from 'react';

const CursorIcon = (props) => (
  <SvgIcon width='24' height='24' style={{ fill: 'currentColor', stroke: 'none' }} {...props}>
    <path
      d='M10.875 19.35L13.3 13.25L19.375 10.8L19.425 10.15L4.57505 4.55005L10.25 19.35H10.875ZM10.575 17.375L6.27505 6.25005L17.45 10.5L12.55 12.475L10.575 17.375Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default memo(CursorIcon);
